export const API_KEY =
  'eGtleXNpYi0wOWIwN2JmNTk2MjI2MzJiZTg4YTM1MjYzZDVjZjI5YzFkM2Q5ZDAyNjZlZDU3YzMxMjQ3OWRhYmQ5ZjZiZDRhLVNscDZ0dEplMng1YThMa1g=';

export const GOOGLE_MAPS_KEY = 'AIzaSyAhHpFB6kq32vsliAG1Y8p6pbg-arjCiks';

export const ID_MAP_KEY = '6dc2b3ba0e568e9f';
